import React from 'react'

function Footer() {
  return (
    <div className='flex justify-center'>
        <p className='text-xs text-zinc-500 my-4'>    
            Copyright © 2021. All Rights Reserved.
        </p>
    </div>
  )
}

export default Footer